import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

const banners = [
  {
    id: 'b1',
    title: '流浪地球3',
    subtitle: '国产科幻巨制，票房突破50亿',
    tag: '热播大片',
    link: '/article/a1',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20epic%20scene%20with%20futuristic%20spaceship%20approaching%20Earth%20from%20space%2C%20dramatic%20orange%20and%20teal%20color%20grading%2C%20planet%20Earth%20glowing%20in%20darkness%2C%20high%20production%20value%20film%20still%2C%20photorealistic%20render%2C%20atmospheric&width=1600&height=700&seq=boluo-hero-1&orientation=landscape',
  },
  {
    id: 'b2',
    title: '哪吒之魔童闹海',
    subtitle: '神话再临，票房奇迹续作',
    tag: '热映中',
    link: '/article/a3',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythological%20fantasy%20animation%20scene%20with%20epic%20battle%20in%20sky%2C%20dramatic%20red%20and%20gold%20color%20palette%2C%20magical%20fire%20effects%2C%20cinematic%20composition%2C%20stylized%20artistic%20rendering&width=1600&height=700&seq=boluo-hero-2&orientation=landscape',
  },
  {
    id: 'b3',
    title: '乘风破浪的姐姐 第五季',
    subtitle: '30位姐姐追梦舞台，破浪前行',
    tag: '热播综艺',
    link: '/article/a4',
    image: 'https://readdy.ai/api/search-image?query=Glamorous%20stage%20performance%20with%20colorful%20spotlights%20and%20silhouettes%20of%20dancers%2C%20entertainment%20show%20atmosphere%2C%20vibrant%20pink%20and%20purple%20lighting%2C%20dynamic%20energy%2C%20concert%20photography%20style&width=1600&height=700&seq=boluo-hero-3&orientation=landscape',
  },
];

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % banners.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + banners.length) % banners.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {banners.map((banner, index) => (
        <div
          key={banner.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={banner.image}
            alt={banner.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
        </div>
      ))}

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto w-full">
            {banners.map((banner, index) => (
              <div
                key={banner.id}
                className={`transition-all duration-700 ${
                  index === current
                    ? 'opacity-100 translate-y-0'
                    : 'opacity-0 translate-y-8 absolute'
                }`}
              >
                {index === current && (
                  <div className="max-w-xl">
                    <span className="inline-block px-3 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
                      {banner.tag}
                    </span>
                    <h2 className="text-3xl md:text-5xl font-bold font-heading text-background-50 mb-3 leading-tight">
                      {banner.title}
                    </h2>
                    <p className="text-base md:text-lg text-background-200 mb-6 leading-relaxed">
                      {banner.subtitle}
                    </p>
                    <Link
                      to={banner.link}
                      className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
                    >
                      <span className="w-5 h-5 flex items-center justify-center">
                        <i className="ri-play-fill"></i>
                      </span>
                      立即观看
                    </Link>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 hover:bg-background-50/40 transition-colors cursor-pointer"
        aria-label="上一个"
      >
        <i className="ri-arrow-left-s-line text-lg md:text-xl"></i>
      </button>
      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 hover:bg-background-50/40 transition-colors cursor-pointer"
        aria-label="下一个"
      >
        <i className="ri-arrow-right-s-line text-lg md:text-xl"></i>
      </button>

      <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2 h-2 md:w-2.5 md:h-2.5 rounded-full transition-all cursor-pointer ${
              index === current
                ? 'bg-primary-500 w-6 md:w-8'
                : 'bg-background-50/50 hover:bg-background-50/80'
            }`}
            aria-label={`切换到第${index + 1}张`}
          ></button>
        ))}
      </div>
    </section>
  );
}